import React from "react";
import { Link } from "react-router-dom";
import { PublicJob, hexAlpha } from "../../types";
import { humanReadableDate } from "../../../../../helper/dateTimeHelper";

interface JobCardProps {
  job: PublicJob;
  career_page_uuid: string;
  viewMode: "grid" | "list";
  primaryColor: string;
}

const JobCard: React.FC<JobCardProps> = ({ job, career_page_uuid, viewMode, primaryColor }) => {
  return (
    <Link
      to={`/careers/${career_page_uuid}/job/${job.public_job_id}`}
      style={{ textDecoration: "none", color: "inherit" }}
    >
      <div
        style={{
          background: "#fff",
          border: "1px solid #e8eaed",
          borderRadius: 14,
          padding: 22,
          cursor: "pointer",
          transition: "all 0.2s",
          display: viewMode === "list" ? "flex" : "block",
          alignItems: viewMode === "list" ? "center" : undefined,
          gap: viewMode === "list" ? 20 : undefined,
          height: viewMode === "grid" ? "100%" : "auto",
          flexDirection: viewMode === "list" ? "row" : "column",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.borderColor = hexAlpha(primaryColor, 0.4);
          e.currentTarget.style.boxShadow = `0 4px 20px ${hexAlpha(primaryColor, 0.1)}`;
          e.currentTarget.style.transform = "translateY(-2px)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.borderColor = "#e8eaed";
          e.currentTarget.style.boxShadow = "none";
          e.currentTarget.style.transform = "none";
        }}
      >
        
        <div style={{ display: "flex", alignItems: "flex-start", gap: 14, flex: viewMode === "list" ? 1 : undefined, marginBottom: viewMode === "grid" ? 14 : 0 }}>
          <div style={{
            width: 42, height: 42, borderRadius: 10, flexShrink: 0,
            background: hexAlpha(primaryColor, 0.1),
            display: "flex", alignItems: "center", justifyContent: "center",
            color: primaryColor, fontSize: 18,
          }}>
            <i className="ti ti-briefcase" />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <h6 style={{ margin: "0 0 3px", fontWeight: 700, fontSize: 16, color: "#1a1a2e", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {job.title}
            </h6>
            <span style={{ fontSize: 13, color: "#888", display: "flex", alignItems: "center", gap: 4 }}>
              <i className="ti ti-building" style={{ fontSize: 12 }} />
              {job.location || "Remote"}
            </span>
          </div>
        </div>

        
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: viewMode === "grid" ? 14 : 0, flex: viewMode === "list" ? 2 : undefined }}>
          <span style={{
            display: "inline-flex", alignItems: "center", gap: 4,
            padding: "3px 10px", borderRadius: 20,
            background: "#f4f5f7", color: "#555", fontSize: 12, fontWeight: 500,
          }}>
            <i className="ti ti-map-pin" style={{ fontSize: 11, color: primaryColor }} />
            {job.work_mode === "remote" ? "Remote" : job.location}
          </span>
          <span style={{
            display: "inline-flex", alignItems: "center", gap: 4,
            padding: "3px 10px", borderRadius: 20,
            background: hexAlpha(primaryColor, 0.08), color: primaryColor, fontSize: 12, fontWeight: 500,
          }}>
            <i className="ti ti-clock" style={{ fontSize: 11 }} />
            {job.employment_type}
          </span>
          {job.salary_range && (
            <span style={{
              display: "inline-flex", alignItems: "center", gap: 4,
              padding: "3px 10px", borderRadius: 20,
              background: "#fff8e7", color: "#b7791f", fontSize: 12, fontWeight: 500,
            }}>
              <i className="ti ti-currency-rupee" style={{ fontSize: 11 }} />
              {job.salary_range.min.toLocaleString()} – {job.salary_range.max.toLocaleString()} {job.salary_range.currency}
            </span>
          )}
        </div>

        
        <div style={{
          display: "flex", justifyContent: "space-between", alignItems: "center",
          marginTop: viewMode === "grid" ? "auto" : 0, 
          paddingTop: viewMode === "grid" ? 14 : 0,
          borderTop: viewMode === "grid" ? "1px solid #f0f0f0" : "none",
          minWidth: viewMode === "list" ? 160 : undefined,
          gap: 10
        }}>
          <span style={{ fontSize: 12, color: "#aaa" }}>
            Posted {humanReadableDate(job.posted_date)}
          </span>
          <span style={{
            display: "flex", alignItems: "center", gap: 4,
            fontSize: 13, fontWeight: 600, color: primaryColor,
          }}>
            View Details <i className="ti ti-arrow-right" style={{ fontSize: 12 }} />
          </span>
        </div>
      </div>
    </Link>
  );
};

export default JobCard;
